import { defaultRules } from "simple-markdown"
import type { MarkdownRule } from "../parsers/MarkdownRule"

export const lineBreak: MarkdownRule = defaultRules.br
